import { defineMessages } from 'react-intl';

export default defineMessages({
    scheduledItems: {
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    coverage:{
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    limit: {
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    deductible: {
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    settlementBasis: {
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    Perlis: {
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    endorsement: {
        id: 'policycommon.component.vehicle-coverage.Endorsement',
        defaultMessage: 'Endorsement'
    },
    discounts: {
        id: 'policycommon.component.vehicle-coverage.Discounts',
        defaultMessage: 'Discounts'
    }

});
